module.exports = __webpack_public_path__ + "static/media/Notifica_audito.101586e7.png";